export const parseStringToInteger = (value: string): number => {
  return value ? parseInt(value, 10) || 0 : 0;
};

export const parseStringToBool = (
  value: string | null | undefined,
): boolean | undefined => {
  return value?.toString().toLowerCase() === 'true';
};

export const parsePostalCode = (value: string | null | undefined): string => {
  return value ? value.replace(/\s/g, '').toUpperCase() : '';
};
